import euImg from "images/new/eu.png";
import londonImg from "images/new/london.png";
import React from "react";

interface OfficeLocation {
  id: number;
  title: string;
  address: string[];
  image: string;
  note?: string;
  mapLink?: string;
}

const offices: OfficeLocation[] = [
  {
    id: 1,
    title: "UK Head Office",
    address: ["Level 18, 40 Bank Street", "Canary Wharf", "London, E14 5NR", "United Kingdom"],
    image: londonImg,
    note: "London is our main office and postal address.",
    mapLink: "https://maps.app.goo.gl/ho4wdo2EzGNwzt4s5",
  },
  {
    id: 2,
    title: "EU Office",
    address: ["Nikis 1, Anthoupoli", "Nicosia, 2350", "Cyprus"],
    image: euImg,
    mapLink: "https://maps.app.goo.gl/UoABAJYbW7P1erXg6",
  },
];

const OfficeLocations: React.FC = () => {
  return (
    <section className="container mx-auto py-20">
      <div className="grid md:grid-cols-2 gap-8">
        {offices.map((office) => (
          <div key={office.id}>
            {/* Image */}
            <div className=" rounded-3xl overflow-hidden">
              <img src={office.image} alt={office.title} className="w-full h-[260px] object-cover rounded-2xl" />
            </div>

            {/* Content */}
            <div className="mt-6">
              <div className="flex justify-between items-start mb-4 min-h-[120px]">
                <h3 className="text-3xl font-semibold">{office.title}</h3>
                <div className="text-right text-gray-600">
                  {office.address.map((line, index) => (
                    <p key={index}>{line}</p>
                  ))}
                </div>
              </div>
              <div className="inline-block">
                <a href={office.mapLink} target="_blank" rel="noopener noreferrer" className="group border border-gray-300 rounded-full px-6 py-2.5 inline-flex items-center gap-2 hover:border-gray-400 transition-colors">
                  <span className="text-gray-900">See on a map</span>
                  <svg className="w-4 h-4 text-gray-600 group-hover:translate-x-0.5 transition-transform" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </a>
              </div>
              {office.note && <p className="text-sm text-gray-500 mt-4">{office.note}</p>}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OfficeLocations;
